// ***** Dependencies *****
import { Button } from "@fc/devteam-components-library";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// ***** Interfaces, Types and imports *****
import ErrorImage from "../../../public/emptystates/errorwindow.svg";

/**
 * Fallback rendered when no route matches. Used by the top level router and by
 * the descendant `<Routes>` of every module, so an unknown URL shows a message
 * instead of an empty content area.
 */
const NotFound = (): JSX.Element => {
    const { t } = useTranslation(["common"]);
    const history = useNavigate();

    return (
        <div className="Construction">
            <img
                className="Construction__Icon"
                src={ErrorImage}
                alt={t("notFound.title")}
            />
            <p className="Construction__Text">{t("notFound.title")}</p>
            <p className="Construction__TextSmall">{t("notFound.text")}</p>
            <div className="ButtonComponent">
                <Button
                    buttontext={t("buttons.back")}
                    buttontype="button"
                    action={() => history(-1)}
                />
            </div>
        </div>
    );
};

export default NotFound;
